interface preCodeProp {
  children: string | React.ReactNode;
}

export const PreCode = ({ children }: preCodeProp) => {
  return <pre style={{ width: "100%" }}>{children}</pre>;
};
